import React from "react";
import Select from 'react-select';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Icon from "components/Varios/Icons.js";
import TooltipItem from "components/Varios/Tooltip.js";

//Otros Localizacion
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
registerLocale('ES', es)




export default class Datepicker2 extends React.Component {

    constructor(props) {
        super(props);
        this.referenciaDatePicker = React.createRef();
    }

    state = {
        date: (this.props.value ? new Date(this.props.value) : null),
        toogleClass: ""

    };

    handleChange = date => {
        this.setState(
            { date },
            (() => { this.props.onChange(date, this.props.name) })
        );
    };


    ToogleActive = () => {
        if (this.referenciaDatePicker.current !== null && this.referenciaDatePicker.current !== undefined) {
            console.log(this.referenciaDatePicker.current.input.click())
        }
    }

    
    

    render() {
        return (
            <div className="input-group">
                <DatePicker
                    ref={this.referenciaDatePicker}
                    className="form-control"
                    selected={this.props.value}
                    onChange={date => this.handleChange(date)}
                    name={this.props.name}
                    id={this.props.id}
                    dateFormat={(this.props.dateFormat ? this.props.dateFormat : "dd/MM/yyyy")}
                    placeholderText={this.props.placeholder}
                    disabled={(this.props.disabled)}
                    showYearPicker={(this.props.dateFormat === "yyyy" ? true : false)}
                    minDate={this.props.min}
                    showDisabledMonthNavigation={this.props.showDisabledMonthNavigation}
                    maxDate={this.props.max}
                    filterDate={this.props.filter}
                    excludeDates={this.props.excludeDates}
                    customInput={<input className="no_autocomplete" autoComplete="off"></input>}
                    dayClassName={this.props.dayClassName}
                    locale="ES"
                    autoComplete="off"
                    showMonthDropdown={this.props.monthdropdown}
                    useShortMonthInDropdown={this.props.monthdropdown}
                    portalId="root"
                    container="body"

                />
                <div className="input-group-append " style={{ backgroundColor: "#FFFFFF", border: "1px solid #E3E3E3", borderLeft: "none" }}>
                    {/*<i className="fas fa-calendar-alt" aria-hidden="true"></i >*/}
                    <Icon kind="calendario" fill='#243165' width={27} height={27} onClick={() => this.ToogleActive()} />
                </div>
                <TooltipItem content={this.props.placeholder} id={this.props.id} />
            </div>
        )

    }
}